import dayjs from 'dayjs';

export const formatSeconds = (seconds: number) =>
  dayjs.utc(seconds * 1000).format(seconds > 3600 ? 'HH:mm:ss' : 'mm:ss');
